import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { PoTableColumn } from "@po-ui/ng-components";
import { environment } from '../../../environments/environment';

const auth = environment.authorization

@Injectable({
  providedIn: "root"
})
export class EstoqueListService {
  url = `${environment.API}produtos`;
  urlEstoque = `${environment.API_PROTHEUS}consultaestoque`;
  headers2 = new HttpHeaders({'authorization':auth, 'tenantid':'01,0301', 'x-erp-module':'FAT', 'Accept-Charset':'UTF-8'});
  constructor(private http: HttpClient) {}

  getEstoquesList(filtro: String): Observable<any> {
    return this.http.post(this.url, {
      filter: filtro
    });
  }

  getEstoque(produto: String): Observable<any> {
    return this.http.get(this.urlEstoque +"/?produtob2="+ produto, {headers: this.headers2} );
  }




  getColumns(): Array<PoTableColumn> {
    return [
      { property: "codigo", label: "Código", width:"30%" },
      { property: "descricao", label: "Descrição", width:"30%" },
      { property: "un", label: "Un.Medida", width:"8%" },
      { property: "ncm", label: "NCM", width:"20%" },
      { property: "estoque",label: "Qtd.Disponível", width:"10%"}
    ];
  }
}
